<ng-template #orderShippingModal let-modal>
    <div class="modal-header justify-content-start border-bottom">
        <div>
            <h3 class="fw-semibold">Lịch sử giao hàng</h3>
            <div class="history-external-link">
                <a href="{{trackingUrl}}" target="_blank" rel="noopener noreferrer">
                    Xem chi tiết trên website của đơn vị vận chuyển
                </a>
            </div>
        </div>
        <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
            (click)="modal.dismiss()">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="p-3">
        <app-shipping-status [data]="data"></app-shipping-status>
    </div>
</ng-template>